module.exports = __webpack_public_path__ + "static/media/lr.5f0e494d.svg";